module.exports = __webpack_public_path__ + "img/jzyl2.2c60c29b.png";